// src/components/layout/TriggerEngineProvider.jsx
// ─────────────────────────────────────────────────────────────────────────────
//  Binds all useSyncStore instances to the trigger engine so that
//  automation handlers can read/write them.
//
//  Mount this inside the router but above all page components.
//  It renders nothing visible — just binds stores on mount, unbinds on unmount.
//
//  FIX W1: All useSyncStore() calls now use STORE_* constants from storeKeys.js
//  instead of bare string literals. The old literals ('milestones', 'habitFlags',
//  'verseClipboard') violated the rule that every useSyncStore key must go
//  through storeKeys.js. A rename of any key would silently diverge with no
//  runtime error.
// ─────────────────────────────────────────────────────────────────────────────
import { useSyncStore, useJournalData } from '@/hooks/sync/useSyncStore';
import { useBindStore } from '@/hooks/automation/useTriggerEngine';
import {
  STORE_HABIT_FLAGS,
  STORE_VERSE_CLIPBOARD,
} from '@/lib/storeKeys';

export default function TriggerEngineProvider({ children }) {
  // ── Bind core stores ────────────────────────────────────────────────────
  const {
    calendarEvents, setCalendarEvents,
    peopleContacts, setPeopleContacts,
  } = useJournalData();

  // FIX W1: use STORE_* constants — no bare string literals
  const [habitFlags,      setHabitFlags]      = useSyncStore(STORE_HABIT_FLAGS,      {});
  const [verseClipboard,  setVerseClipboard]  = useSyncStore(STORE_VERSE_CLIPBOARD,  []);

  useBindStore('calendarEvents', calendarEvents, setCalendarEvents);
  useBindStore('peopleContacts', peopleContacts, setPeopleContacts);
  useBindStore('habitFlags',     habitFlags,     setHabitFlags);
  useBindStore('verseClipboard', verseClipboard, setVerseClipboard);

  return children;
}